export default "__VITE_PUBLIC_ASSET__c81679c1__"